<div class="popup-dialog-window">
  <div class="app-dialog-title">
    {{ data.title }}
    <button class="btn-x" (click)="dialogRef.close(false)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="app-dialog-content">
    <div *ngIf="data.icon" class="message-row">
      <mat-icon>{{ data.icon }}</mat-icon>

      <span class="msg-bold dialog-message">{{ data.message1 }}</span>
    </div>

    <p class="msg-bold" style="text-align: center" *ngIf="!data.icon">{{ data.message1 }}</p>
    <p class="msg-bold" style="text-align: center" *ngIf="data.message2">{{ data.message2 }}</p>

    <div *ngIf="data.radioOptions?.length" class="radio-group">
      <label *ngFor="let option of data.radioOptions" class="radio-item">
        <input type="radio" name="radioGroup" [value]="option" [(ngModel)]="selectedOption" />
        {{ option }}
      </label>
    </div>

    <div *ngIf="data.dropdownOptions?.length" class="dropdown-group">
      <label class="visually-hidden" for="confirmationDropdown">{{
        data.dropdownLabel || 'Select an option'
      }}</label>
      <select
        id="confirmationDropdown"
        class="message-type-select"
        name="confirmationDropdown"
        [(ngModel)]="selectedKey"
      >
        <option *ngFor="let opt of data.dropdownOptions" [value]="opt.key">
          {{ opt.value }}
        </option>
      </select>
    </div>
    <div
      class="app-dialog-footer"
      [ngClass]="{
        'single-button': !data.noText,
        'two-buttons': !!data.noText
      }"
    >
      <button class="yes-btn" (click)="onConfirm()">
        {{ data.yesText || 'Yes' }}
      </button>

      <button *ngIf="data.noText" class="close-btn" (click)="onCancel()">
        {{ data.noText }}
      </button>
    </div>
   
  </div>
</div>
